module.exports = __webpack_public_path__ + "static/img/icon_case_4.7dcd9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_case_4.png
// module id = 0GNO
// module chunks = 0